import { render, staticRenderFns } from "./extendingCenter.vue?vue&type=template&id=21d8205d&scoped=true&"
import script from "./extendingCenter.vue?vue&type=script&lang=js&"
export * from "./extendingCenter.vue?vue&type=script&lang=js&"
import style0 from "./extendingCenter.vue?vue&type=style&index=0&id=21d8205d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8205d",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/toutiaoApp/extendingCenter.vue
// module id = null
// module chunks = 